export const CITATION_INDEX_SAMPLE = 'js-citation-index-sample';
export const CITATION_SAMPLE = 'js-citation-sample';
export const CITATIONS_LIST_CONTAINER = 'js-citations-list';
export const CITATIONS_CONTAINER = 'js-citations-container';
export const CITATIONS_TAG = 'citations';
export const CITATIONS_SHOW_ALL = 'js-citations-show-all';
export const CITATIONS_LIST_CONTAINER_COLLAPSED = 'scientific-citations__citations--collapsed';
